import { format, formatDistanceToNowStrict, parseISO } from 'date-fns';

export function formatDateTime(value?: string | null) {
  if (!value) return '—';
  try {
    return format(parseISO(value), 'PPpp');
  } catch {
    return value;
  }
}

export function formatRelative(value?: string | null) {
  if (!value) return '—';
  try {
    return formatDistanceToNowStrict(parseISO(value), { addSuffix: true });
  } catch {
    return value;
  }
}

export function formatNumber(value: number) {
  return new Intl.NumberFormat().format(value);
}

